import { getAssets } from './functions/getAssets';
import { __ } from './functions/__';
import { getMarket } from "./functions/getMarket";

/**
 * Zoznam obrazkov.
 */
export const IMAGES = getAssets(require.context('./assets/img/', false, /\.(png|jpe?g|svg|gif)$/));

/**
 * Zoznam mien.
 *
 * @type {Object}
 */
export const CURRENCIES = {
    EUR: '€',
    CZK: 'Kč',
    HUF: 'Ft',
    USD: '$',
    GBP: '£',
    PLN: 'zł',
    BGN: 'лв',
    DKK: 'kr',
    RON: 'lei',
    SEK: 'kr',
};

export const TIMEZONES = {
    '-13': 'UTC-12:00',
    '-12': 'UTC-11:00',
    '-11': 'UTC-10:00',
    '-10': 'UTC-09:00',
    '-9': 'UTC-08:00',
    '-8': 'UTC-07:00',
    '-7': 'UTC-06:00',
    '-6': 'UTC-05:00',
    '-5': 'UTC-04:00',
    '-4': 'UTC-03:00',
    '-3': 'UTC-02:00',
    '-2': 'UTC-01:00',
    '-1': 'UTC+00:00',
    '-0': 'UTC+01:00',
    '1': 'UTC+02:00',
    '2': 'UTC+03:00',
    '3': 'UTC+04:00',
    '4': 'UTC+05:00',
    '5': 'UTC+06:00',
    '6': 'UTC+07:00',
    '7': 'UTC+08:00',
    '8': 'UTC+09:00',
    '9': 'UTC+10:00',
    '10': 'UTC+11:00',
    '11': 'UTC+12:00',
    '12': 'UTC+13:00',
    '13': 'UTC+14:00',
};

export const WEIGHT_UNITS = {
    'kg': 'kg',
    'lb': 'lb',
};

export const DIMENSION_UNITS = {
    'cm': 'cm',
    'in': 'in',
};

export const TIME_FORMATS = {
    'his': '24-hour',
    'ampm': 'AM/PM',
};

/**
 * Nazvy eshopov.
 *
 * @type {Object}
 */
export const ESHOPS = {
    Webareal: __('Webareal'),
    WooCommerce: __('WooCommerce'),
    Shopify: __('Shopify'),
    CsCart: __('CS-Cart'),
    EshopRychlo: __('Eshop rychlo'),
    BiznisWeb: __('BiznisWeb'),
    Wix: __('Wix'),
    Api: __('API'),
    Ecwid: __('Ecwid'),
    Prestashop: __('Prestashop'),
    Magento: __('Magento'),
    Upgates: __('Upgates'),
    FastCentrik: __('FASTCentrik'),
    Shoprenter: __('Shoprenter'),
    Eli: __('Eliadmin'),
    Unas: __('Unas'),
    CreativeSites: __('CreativeSites'),
    Shoptet: __('Shoptet'),
    Shoper: __('Shoper'),
    MerchantPro: __('MerchantPro'),
    Gomag: __('Gomag'),
    IdoSell: __('IdoSell'),
    SkyShop: __('SkyShop'),
    Selly: __('Selly'),
    RedCart: __('RedCart'),
    // Last
    Blank: __('Prázdny eshop'),
};

/**
 * Farby fakturacnych systemov.
 *
 * @type {Object}
 */
export const ESHOP_COLORS = {
    Webareal: { background: '#55bcfb', text: 'white' },
    WooCommerce: { background: '#995c8d', text: 'white' },
    Shopify: { background: 'white', text: 'black' },
    CsCart: { background: 'white', text: 'black' },
    EshopRychlo: { background: 'white', text: 'black' },
    BiznisWeb: { background: 'white', text: 'black' },
    Wix: { background: '#1677ff', text: 'white' },
    Api: { background: '#cfa14c', text: 'white' },
    Ecwid: { background: '#0086cc', text: 'white' },
    Prestashop: { background: 'white', text: 'black' },
    Magento: { background: 'white', text: 'black' },
    Upgates: { background: 'white', text: 'black' },
    FastCentrik: { background: 'white', text: 'black' },
    Shoprenter: { background: 'white', text: 'black' },
    Blank: { background: 'white', text: 'black' },
    Eli: { background: 'white', text: 'black' },
    Unas: { background: '#31363e', text: 'white' },
    CreativeSites: { background: 'white', text: 'black' },
    Shoptet: { background: 'white', text: 'black' },
    Shoper: { background: '#1858f8', text: 'white' },
    MerchantPro: { background: '#242474', text: 'white' },
    Gomag: { background: 'white', text: 'black' },
    IdoSell: { background: 'white', text: 'black' },
    SkyShop: { background: 'white', text: 'black' },
    Selly: { background: '#e44621', text: 'white' },
    RedCart: { background: 'white', text: 'black' },
};

/**
 * Eshopy pozicie.
 *
 * @type {Object}
 */
export const ESHOP_POSITIONS = {
    Webareal: { left: -100, top: 230, bottom: 0, right: 0 },
    WooCommerce: { left: 'auto', top: 330, bottom: 0, right: -100 },
    Shopify: { left: 0, top: 530, bottom: 0, right: 0 },
    CsCart: { left: 'auto', top: 630, bottom: 0, right: 0 },
    Shoper: { left: 100, top: 330, bottom: 0, right: 0 },
    MerchantPro: { left: 'auto', top: 430, bottom: 0, right: 50 },
    Wix: { left: 170, top: 180, bottom: 0, right: 0 },
    Gomag: { left: 'auto', top: 190, bottom: 0, right: 200 },
    Ecwid: { left: 200, top: 630, bottom: 0, right: 0 },
    Prestashop: { left: 'auto', top: 630, bottom: 0, right: 170 },
    Magento: { left: -100, top: 430, bottom: 0, right: 0 },
    Upgates: { left: 'auto', top: 680, bottom: 0, right: 140 },
    Selly: { left: 'auto', top: 180, right: -50, bottom: 0 },
    IdoSell: { left: 80, top: 410, right: 0, bottom: 0 },
    SkyShop: { left: 40, top: 480, right: 0, bottom: 0 },
};

/**
 * Zoznam kurierov.
 *
 * @type {Object}
 */
export const COURIERS = {
    Gls: __('GLS'),
    SlovenskaPosta: __('Slovenská pošta'),
    Zasielkovna: __('Packeta'),
    Kurier123: __('123Kuriér'),
    Remax: __('Remax'),
    Dpd: __('DPD SK'),
    Geis: __('GEIS Cargo'),
    Toptrans: __('Toptrans'),
    Fhb: __('FHB Fulfillment'),
    Ppl: __('PPL'),
    Dhl: __('DHL'),
    Sps: __('SPS'),
    ExpressOne: __('EXPRESS ONE'),
    PaletExpress: __('PaletExpress'),
    Sds: __('SDS'),
    Depo: __('DEPO'),
    DpdCz: __('DPD CZ'),
    Mpl: __('Magyar Posta'),
    Qdl: __('QDL'),
    Allegro: __('Allegro'),
    Fedex: __('Fedex'),
    Acs: __('ACS'),
    Posta: __('Slovenská pošta'),
    BoxNow: __('BoxNow'),
    DpdHu: __('DPD HU'),
    DpdPl: __('DPD PL'),
    DpdRo: __('DPD RO'),
    FanCourier: __('FAN Courier'),
    Foxpost: __('FOXPOST'),
    Inpost: __('InPost'),
    PocztaPolska: __('Poczta Polska'),
    Sameday: __('Sameday'),
    Boxpi: __('Boxpi'),
    Cargus: __('Cargus'),
    Rainpro: 'RainPRO',
    Poiint: __('Poiint'),
};

/**
 * Farby kurierov.
 *
 * @type {Object}
 */
export const COURIER_COLORS = {
    Gls: { background: 'white', text: 'black' },
    SlovenskaPosta: { background: '#fabb00', text: 'white' },
    Zasielkovna: { background: '#ba1b02', text: 'white' },
    Kurier123: { background: 'white', text: 'black' },
    Remax: { background: 'white', text: 'black' },
    Dpd: { background: 'white', text: 'black' },
    Geis: { background: '#ffe800', text: 'white' },
    Toptrans: { background: 'white', text: 'black' },
    Fhb: { background: 'white', text: 'black' },
    Ppl: { background: 'white', text: 'black' },
    Dhl: { background: '#ffcc00', text: 'white' },
    Sps: { background: '#46515c', text: 'white' },
    ExpressOne: { background: 'white', text: 'black' },
    PaletExpress: { background: 'white', text: 'black' },
    Sds: { background: '#272a68', text: 'black' },
    Depo: { background: 'white', text: 'black' },
    DpdCz: { background: 'white', text: 'black' },
    Mpl: { background: '#33ab49', text: 'white' },
    Qdl: { background: '#68b237', text: 'white' },
    Allegro: { background: 'white', text: 'black' },
    Fedex: { background: '#4e2c8c', text: 'white' },
    Acs: { background: 'white', text: 'black' },
    Posta: { background: '#fabb00', text: 'white' },
    BoxNow: { background: '#43d63d', text: 'white' },
    DpdHu: { background: 'white', text: 'black' },
    DpdPl: { background: 'white', text: 'black' },
    DpdRo: { background: 'white', text: 'black' },
    FanCourier: { background: '#0f2344', text: 'white' },
    Foxpost: { background: '#b82228', text: 'white' },
    Inpost: { background: '#ffcb37', text: 'white' },
    PocztaPolska: { background: '#e01322', text: 'white' },
    Sameday: { background: 'white', text: 'black' },
    Boxpi: { background: 'white', text: 'black' },
    Cargus: { background: 'white', text: 'black' },
    Rainpro: { background: 'white', text: 'black' },
    Poiint: { background: 'white', text: 'black' },
};

/**
 * Pozicie kurierov.
 *
 * @type {Object}
 */
export const COURIER_POSITIONS = {
    Gls: { left: 0, top: 310, right: 0, bottom: 0 },
    PocztaPolska: { left: 'auto', top: 330, right: -20, bottom: 0 },
    Zasielkovna: { left: -50, top: 180, right: 0, bottom: 0 },
    Dpd: { left: 80, top: 410, right: 0, bottom: 0 },
    Geis: { left: 'auto', top: 370, right: 80, bottom: 0 },
    Sameday: { left: -20, top: 610, right: 0, bottom: 0 },
    FanCourier: { left: 'auto', top: 610, right: -100, bottom: 0 },
    Ppl: { left: 50, top: 690, right: 0, bottom: 0 },
    Dhl: { left: 'auto', top: 530, right: 20, bottom: 0 },
    Sps: { left: 120, top: 230, right: 0, bottom: 0 },
    ExpressOne: { left: 190, top: 560, right: 0, bottom: 0 },
    Foxpost: { left: 'auto', top: 560, right: 180, bottom: 0 },
    Sds: { left: -100, top: 560, right: 0, bottom: 0 },
    Depo: { left: 'auto', top: 480, right: -100, bottom: 0 },
    Inpost: { left: 'auto', top: 180, right: -50, bottom: 0 },
    Posta: { left: 'auto', top: 330, right: -20, bottom: 0 },
};

/**
 * Nazvy skladov.
 *
 * @type {Object}
 */
export const STORAGES = {
    Oberon: __('Oberon'),
    Ikelp: __('iKelp'),
    Mrp: __('MRP'),
    Idoklad: __('iDoklad'),
    Pohoda: __('Pohoda'),
    Onix: __('ONIX'),
    Abra: __('ABRA Flexi'),
    SuperFaktura: __('SuperFaktúra'),
    MoneyS3: __('Money S3'),
    PohodaServer: __('Pohoda mServer'),
    KrosFakturacia: __('KROS fakturácia'),
    MkSoft: __('MK-soft'),
    Brani: __('Brani'),
};

/**
 * Farby skladov.
 *
 * @type {Object}
 */
export const STORAGE_COLORS = {
    Oberon: { background: '#552b83', text: 'white' },
    Ikelp: { background: 'white', text: 'black' },
    Mrp: { background: 'white', text: 'black' },
    Idoklad: { background: 'white', text: 'black' },
    Pohoda: { background: 'white', text: 'black' },
    Onix: { background: 'white', text: 'black' },
    Abra: { background: '#f6b12e', text: 'white' },
    SuperFaktura: { background: 'white', text: 'black' },
    MoneyS3: { background: 'white', text: 'black' },
    PohodaServer: { background: 'white', text: 'black' },
    KrosFakturacia: { background: 'white', text: 'black' },
    MkSoft: { background: 'white', text: 'black' },
    Brani: { background: '#fe1f9a', text: 'white' },
};

/**
 * Zoznam bank.
 *
 * @type {Object}
 */
export const BANKS = {
    Tatrabanka: __('Tatrabanka'),
    Slsp: __('Slovenská sporiteľňa'),
    Moneta: __('Moneta'),
    Fio: __('Fio'),
    Citfin: __('Citfin'),
    Csp: __('Česká sporiteľňa'),
    Vub: __('VÚB'),
    Ai: __('Univerzálne napojenie cez AI'),
};

/**
 * Farby bank.
 *
 * @type {Object}
 */
export const BANK_COLORS = {
    Tatrabanka: { background: 'black', text: 'white' },
    Slsp: { background: '#bce5fb', text: 'white' },
    Moneta: { background: 'white', text: 'black' },
    Fio: { background: 'white', text: 'black' },
    Citfin: { background: 'white', text: 'black' },
    Csp: { background: '#bce5fb', text: 'white' },
    Vub: { background: 'white', text: 'black' },
    Ai: { background: 'white', text: 'black' },
};

/**
 * Farby bank.
 *
 * @type {Object}
 */
export const BANK_POSITIONS = {
    Tatrabanka: { left: 50, top: 280, right: 0, bottom: 0 },
    Slsp: { left: 'auto', top: 280, right: 100, bottom: 0 },
    Moneta: { left: -80, top: 380, right: 0, bottom: 0 },
    Fio: { left: 'auto', top: 390, right: -80, bottom: 0 },
    Citfin: { left: -20, top: 480, right: 0, bottom: 0 },
    Csp: { left: 'auto', top: 470, right: -20, bottom: 0 },
    Vub: { left: -20, top: 670, right: 'auto', bottom: 0 },
};

/**
 * Zoznam platobnych bran.
 *
 * @type {Object}
 */
export const GATEWAYS = {
    Stripe: __('Stripe'),
    Besteron: __('Besteron'),
    Gopay: __('Gopay'),
    Mollie: __('Mollie'),
    Webpay: __('GP webpay'),
    Paypal: __('Paypal'),
};

/**
 * Farby platobnych bran.
 *
 * @type {Object}
 */
export const GATEWAYS_COLORS = {
    Stripe: { background: '#635bff', text: 'white' },
    Besteron: { background: '#e21644', text: 'white' },
    Gopay: { background: 'white', text: 'black' },
    Mollie: { background: '#0096ff', text: 'white' },
    Webpay: { background: 'white', text: 'black' },
    Paypal: { background: 'white', text: 'black' },
};

/**
 * Pozicie platobnych bran.
 *
 * @type {Object}
 */
export const GATEWAYS_POSITIONS = {
    Stripe: { left: 40, top: 580, right: 0, bottom: 0 },
    Besteron: { left: 'auto', top: 580, right: 40, bottom: 0 },
    Gopay: { left: 'auto', top: 630, right: 100, bottom: 0 },
    Mollie: { left: 100, top: 630, right: 0, bottom: 0 },
    Webpay: { left: 120, top: 710, right: 0, bottom: 0 },
};

/**
 * Zoznam trhovisk.
 *
 * @type {Object}
 */
export const MARKETPLACES = {
    Heureka: __('Heureka'),
    Mall: __('Mall'),
    Amazon: __('Amazon'),
    Ebay: __('Ebay'),
    Etsy: __('Etsy'),
    Alza: __('Alza'),
    Kaufland: __('Kaufland'),
    Zbozi: __('Zboží'),
    Ekokrajina: __('Ekokrajina'),
    Allegro: __('Allegro'),
    Emag: __('EMAG'),
};

/**
 * Farby platobnych bran.
 *
 * @type {Object}
 */
export const MARKETPLACES_COLORS = {
    Heureka: { background: 'white', text: 'black' },
    Mall: { background: '#cc0000', text: 'white' },
    Amazon: { background: 'white', text: 'black' },
    Ebay: { background: 'white', text: 'black' },
    Etsy: { background: 'white', text: 'black' },
    Alza: { background: 'white', text: 'black' },
    Kaufland: { background: 'white', text: 'black' },
    Zbozi: { background: 'white', text: 'black' },
    Ekokrajina: { background: 'white', text: 'black' },
    Allegro: { background: 'white', text: 'black' },
    Emag: { background: 'white', text: 'black' },
};

/**
 * Pozicie platobnych bran.
 *
 * @type {Object}
 */
export const MARKETPLACES_POSITIONS = {
    Heureka: { left: -30, top: 250, right: 0, bottom: 0 },
    Mall: { left: 'auto', top: 250, right: -20, bottom: 0 },
    Amazon: { left: -30, top: 425, right: 0, bottom: 0 },
    Ebay: { left: 'auto', top: 200, right: 120, bottom: 0 },
    Etsy: { left: 'auto', top: 530, right: -50, bottom: 0 },
    Alza: { left: 'auto', top: 580, right: -30, bottom: 0 },
    Kaufland: { left: -90, top: 500, right: 0, bottom: 0 },
    Emag: { left: 'auto', top: 310, right: 40, bottom: 0 },
    Allegro: { left: 'auto', top: 260, right: 45, bottom: 0 },
};

/**
 * AI mailer sources.
 *
 * @type {Object}
 */
export const AI_MAILER_SOURCES = {
    Imap: __('Email'),
    Ladesk: __('LiveAgent'),
    Helper: 'Helper',
};

/**
 * Farby platobnych bran.
 *
 * @type {Object}
 */
export const AI_MAILER_COLORS = {
    Imap: { background: '#1b6ba9', text: 'white' },
    Ladesk: { background: 'white', text: 'black' },
    Helper: { background: '#1b6ba9', text: 'white' },
};

/**
 * Zdroje objednavok.
 *
 * @type {Object}
 */
export const ORDER_SOURCES = {
    heureka: { background: '#ef7000', name: __('Heureka') },
    mall: { background: '#cc0000', name: __('Mall') },
    kaufland: { background: '#e3000f', name: __('Kaufland') },
    allegro: { background: '#ff5a09', name: __('Allegro') },
    etsy: { background: '#f4580a', name: __('Etsy') },
    manual: { background: '#5c70ff', name: __('Manuálne') },
    emag: { background: '#a43188', name: __('EMAG') },
};

/**
 * Zoznam addonov.
 *
 * @type {Object}
 */
export const ADDONS = {
    Kodas: __('Kodas'),
    Ikelp: __('iKelp'),
    Spajame: __('Spajame'),
    Mrp: __('Mrp XML export'),
    Pohoda: __('Pohoda XML export platieb'),
    Money: __('Money S3'),
    Stripe: __('Stripe'),
    Omega: __('Omega TXT export'),
    PohodaOrders: __('Pohoda XML export platieb'),
};

/**
 * Farby addonov.
 *
 * @type {Object}
 */
export const ADDON_COLORS = {
    Kodas: { background: 'white', text: 'black' },
    Ikelp: { background: 'white', text: 'black' },
    Spajame: { background: 'white', text: 'black' },
    Mrp: { background: 'white', text: 'black' },
    Pohoda: { background: 'white', text: 'black' },
    Money: { background: 'white', text: 'black' },
    Stripe: { background: '#635bff', text: 'white' },
    Omega: { background: 'white', text: 'black' },
    PohodaOrders: { background: 'white', text: 'black' },
};

/**
 * Nazvy fakturacnych systemov.
 *
 * @type {Object}
 */
export const ACCOUNTINGS = {
    SuperFaktura: __('SuperFaktúra'),
    Idoklad: __('iDoklad'),
    Omega: __('Omega'),
    Kros: __('Omega'),
    Oberon: __('Oberon'),
    Pohoda: __('Pohoda'),
    MkSoft: __('MKsoft'),
    Ikros: __('iKROS'),
    Mrp: __('MRP'),
    FakturyOnline: __('Faktúry online'),
    Fakturoid: __('Fakturoid'),
    Money: __('Money S3'),
    Profit365: __('Profit365'),
    MoneyS4: __('Money S4'),
    Billdu: __('Billdu'),
    Vyfakturuj: __('Vyfakturuj'),
    Onix: __('ONIX'),
    Abra: __('ABRA Flexi'),
    EshopRychlo: __('Eshop Rychlo'),
    PohodaServer: __('Pohoda mServer'),
    Webareal: __('Webareal'),
    Inteo: __('Omega'),
    KrosFakturacia: __('KROS fakturácia'),
    Szamlazz: __('Számlázz'),
    Billingo: __('Billingo'),
    SmartBill: __('SmartBill'),
    Oblio: __('Oblio'),
    Fakturownia: __('Fakturownia'),
    Ifirma: __('IFIRMA'),
    Infakt: __('inFakt'),
    Wfirma: __('wFirma'),
    FreshBooks: __('FreshBooks'),
    Xero: __('Xero'),
    Flowii: __('Flowii'),
};

/**
 * Farby fakturacnych systemov.
 *
 * @type {Object}
 */
export const ACCOUNTING_COLORS = {
    SuperFaktura: { background: 'white', text: 'black' },
    Idoklad: { background: 'white', text: 'black' },
    Omega: { background: 'white', text: 'black' },
    Kros: { background: 'white', text: 'black' },
    Oberon: { background: '#552b83', text: 'white' },
    Pohoda: { background: 'white', text: 'black' },
    MkSoft: { background: 'white', text: 'black' },
    Ikros: { background: 'white', text: 'black' },
    Mrp: { background: 'white', text: 'black' },
    FakturyOnline: { background: 'white', text: 'black' },
    Fakturoid: { background: 'white', text: 'black' },
    Money: { background: 'white', text: 'black' },
    Profit365: { background: 'white', text: 'black' },
    MoneyS4: { background: 'white', text: 'black' },
    Billdu: { background: '#002af2', text: 'white' },
    Vyfakturuj: { background: 'white', text: 'black' },
    Onix: { background: 'white', text: 'black' },
    Abra: { background: '#f6b12e', text: 'white' },
    EshopRychlo: { background: 'white', text: 'black' },
    PohodaServer: { background: 'white', text: 'black' },
    Webareal: { background: '#55bcfb', text: 'white' },
    Inteo: { background: 'white', text: 'black' },
    KrosFakturacia: { background: 'white', text: 'black' },
    Szamlazz: { background: '#ff6632', text: 'white' },
    Billingo: { background: 'white', text: 'black' },
    SmartBill: { background: 'white', text: 'black' },
    Oblio: { background: '#27153e', text: 'white' },
    Fakturownia: { background: 'white', text: 'black' },
    Ifirma: { background: 'white', text: 'black' },
    Infakt: { background: '#1f88e5', text: 'black' },
    Wfirma: { background: 'white', text: 'black' },
    FreshBooks: { background: '#0375dd', text: 'black' },
    Xero: { background: '#2ec0e5', text: 'black' },
    Flowii: { background: 'white', text: 'black' },
};

/**
 * Pozicie fakturacnych systemov.
 *
 * @type {Object}
 */
export const ACCOUNTING_POSITIONS = {
    SuperFaktura: { left: 30, top: 210, right: 0, bottom: 0 },
    Idoklad: { left: 'auto', top: 210, right: 30, bottom: 0 },
    Omega: { left: -80, top: 290, right: 0, bottom: 0 },
    Szamlazz: { left: 'auto', top: 270, right: -80, bottom: 0 },
    Pohoda: { left: 10, top: 370, right: 0, bottom: 0 },
    SmartBill: { left: 'auto', top: 410, right: -20, bottom: 0 },
    Fakturoid: { left: 'auto', top: 480, right: 40, bottom: 0 },
    Fakturownia: { left: 120, top: 550, right: 0, bottom: 0 },
    Infakt: { left: 'auto', top: 550, right: 120, bottom: 0 },
    Billdu: { left: -80, top: 650, right: 0, bottom: 0 },
    FreshBooks: { left: 'auto', top: 650, right: -50, bottom: 0 },
    Billingo: { left: 180, top: 690, right: 0, bottom: 0 },
    Abra: { left: 'auto', top: 690, right: 70, bottom: 0 },
};

/**
 * AI translate function slug.
 *
 * @type {string}
 */
export const AI_TRANSLATE_FUNCTION_SLUG = 'TranslatesTextIntoTheSelectedLanguage';

export const AI_TYPE_SETTINGS = {
    creative: { temperature: 1, top_p: 0.9, presence_penalty: 1.2, frequency_penalty: 0.8 },
    formal: { temperature: 0.3, top_p: 0.7, presence_penalty: 0, frequency_penalty: 0 },
    antiformal: { temperature: 0.7, top_p: 0.95, presence_penalty: 0.6, frequency_penalty: 0.4 },
    technic: { temperature: 0, top_p: 1, presence_penalty: 0.2, frequency_penalty: 0.1 },
    explorer: { temperature: 0.8, top_p: 0.9, presence_penalty: 1, frequency_penalty: 0.3 },
    minimalist: { temperature: 0.2, top_p: 0.6, presence_penalty: 0, frequency_penalty: 0.5 },
    repetitive: { temperature: 0.9, top_p: 1, presence_penalty: 0, frequency_penalty: 0 },
    poet: { temperature: 1.3, top_p: 0.85, presence_penalty: 1.5, frequency_penalty: 0.6 },
    brainstorming: { temperature: 1.1, top_p: 0.95, presence_penalty: 1.2, frequency_penalty: 0.2 },
    answers: { temperature: 0.5, top_p: 1, presence_penalty: 0, frequency_penalty: 1.5 },
};

export const AI_EXTENSIONS_NOT_FILE_SEARCH = ['csv', 'xls', 'xlsx', 'xml'];

/**
 * Minimalna dlzka hesla.
 *
 * @type {number}
 */
export const PASSWORD_MIN_LENGTH = 8;

/**
 * Customizacia.
 *
 * @type {Object}
 */
export const CUSTOMIZATION = {
    'objednavky.ezdrav.sk': { key: 'ezdrav', domain: 'Ezdrav.sk' },
    'objednavky.royalpets.sk': { key: 'royalpets', domain: 'RoyalPets.sk' },
    'system.owicreative.sk': { key: 'owicreative', domain: 'owicreative.sk' },
    //'localhost:3000': { key: 'mtokna', domain: 'mtokna.sk' },
    'toppredajca.dobrezeleziarstvo.sk': { key: 'mtokna', domain: 'mtokna.sk' },
    'www.toppredajca.dobrezeleziarstvo.sk': { key: 'mtokna', domain: 'mtokna.sk' },
    'portal.rainpro.sk': { key: 'rainpro', domain: 'rainpro.sk' },
    'www.portal.rainpro.sk': { key: 'rainpro', domain: 'rainpro.sk' },
};

export const CUSTOM_ORDER_PAGES = [
    'objednavka.dobrezeleziarstvo.sk',
    'objednavka.vsetkopreokna.sk',
    'objednavka.supersarkany.sk',
    'objednavka.vsechnoprookna.cz',
    'objednavka.dielynaokna.sk',
];

/**
 * Demo token.
 *
 * @type {string}
 */
export const DEMO_TOKEN = 'd4c7d48e4b2753ea30a4886dc5ea5bca7fc876fd';

/**
 * Cookie token name.
 *
 * @type {string}
 */
export const COOKIE_TOKEN_NAME = 'goodeshop-token';

/**
 * Cookie device token name.
 *
 * @type {string}
 */
export const COOKIE_DEVICE_TOKEN_NAME = 'goodeshop-devicetoken';

/**
 * Cookie token name.
 *
 * @type {string}
 */
export const COOKIE_AFFILIATE_NAME = 'goodeshop-affiliate';

/**
 * Cookie read name.
 *
 * @type {string}
 */
export const COOKIE_READ_NAME = 'goodeshop-read';

/**
 * Cookie webareal name.
 *
 * @type {string}
 */
export const COOKIE_WEBAREAL_NAME = 'goodeshop-webareal';

/**
 * Cookie source name.
 *
 * @type {string}
 */
export const COOKIE_SOURCE_NAME = 'goodeshop-source';

/**
 * Cookie offer name.
 *
 * @type {string}
 */
export const COOKIE_OFFER_NAME = 'goodeshop-offer4';

/**
 * Cookie apps name.
 *
 * @type {string}
 */
export const COOKIE_APPS_NAME = 'goodeshop-apps';

/**
 * Cookie AI functions name.
 *
 * @type {string}
 */
export const COOKIE_AI_FUNCTIONS_NAME = 'goodeshop-ai-functions2';

/**
 * Cookie AI addons name.
 *
 * @type {string}
 */
export const COOKIE_AI_ADDONS_NAME = 'goodeshop-ai-addons2';

/**
 * Cookie AI agents name.
 *
 * @type {string}
 */
export const COOKIE_AI_AGENTS_NAME = 'goodeshop-ai-agents';

/**
 * Nastavenia cookie.
 *
 * @type {Object}
 */
export const COOKIE_SETTINGS = process.env.NODE_ENV && process.env.NODE_ENV === 'production'
    ? { path: '/', domain: window.location.host.replace('www.app.', '').replace('app.', '') }
    : {};

/**
 * Market.
 *
 * @type {string}
 */
export const MARKET = getMarket();

/**
 * Development url.
 *
 * @type {string}
 */
export const DEVELOPMENT_URL = 'https://api.fynode.com';

/**
 * Production url.
 *
 * @type {string}
 */
export const PRODUCTION_URL = 'https://api.fynode.com';

/**
 * Wiki url.
 *
 * @type {string}
 */
export const WIKI_URL = 'https://docs.fynode.com';
